import Swal from 'sweetalert2';

let duplicateLoginAlertPromise = null;

export const showDuplicateLoginAlert = () => {
  if (duplicateLoginAlertPromise) {
    return duplicateLoginAlertPromise;
  }

  duplicateLoginAlertPromise = Swal.fire({
    icon: 'warning',
    title: 'Sessão encerrada',
    text: 'Foi detectado login duplicado ou a sua sessão expirou. Faça login novamente.',
    confirmButtonText: 'Ir para login',
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    sessionStorage.clear();
    localStorage.removeItem('serviceToken');
    window.location.href = '/auth/login';
  }).finally(() => {
    duplicateLoginAlertPromise = null;
  });

  return duplicateLoginAlertPromise;
};

export default showDuplicateLoginAlert;